export const faq = [
  {
    type: 'Laerについて'
  },
  {
    id: 'Laerとはどのようなサービスですか？',
    question: 'Laerとはどのようなサービスですか？',
    answer: `Laer（レア）は、特別な距離で大好きなVTuberを支援できるファンコミュニケーションサービスです。

月額制でVTuberを支援することで、毎月決まった時間、1対1のアバター通話で交流できます。`
  },
  {
    id: `アバター通話とは？`,
    question: `アバター通話とは？`,
    answer: `アバター通話とは、バーチャルアバターを用いておこなうビデオ通話です。

お互いにバーチャルアバターを用いて通話するため、顔出し不要で大好きなVTuberと1対1でお話できます。`
  },
  {
    id: `VRアバターを持っていないのですがLaerを使用できますか？`,
    question: `VRアバターを持っていないのですがLaerを使用できますか？`,
    answer: `VTuberを支援される方は、Laerで用意している3Dアバターをご利用いただけるため、VRアバターをもっていなくても問題ありません。`
  },
  {
    id: `Laerを使用するにはVRデバイスが必要ですか？`,
    question: `Laerを使用するにはVRデバイスが必要ですか？`,
    answer: `LaerはスマートフォンやPCのブラウザからご利用いただけるため、VRデバイスは必要ありません。`
  },







  {
    type: '基本的な使い方'
  },
  {
    id: `支援の始め方がわからない`,
    question: `支援の始め方がわからない`,
    answer: `各クリエイターの支援ページで、お好きなプランの「支援する」ボタンをクリックしていただくことで、支援の開始ページに遷移します。

支援内容を確認し、決済情報を入力して「支援をはじめる」をクリックすると支援が開始します。`
  },
  {
    id: `対応している決済方法について`,
    question: `対応している決済方法について`,
    answer: `決済にはクレジットカード（VISA, MASTER, Diners Club）がご利用いただけます。

クレジットカードをお持ちでない方は、Kyashのバーチャルカードにチャージいただくことで、コンビニや銀行経由でお支払い頂けます。
※Kyashカードをご利用される場合は、毎月末日までに翌月分の支援金をKyashカードにチャージしていただく必要があります。`
  },
  {
    id: `支援金が請求されるタイミングはいつですか？`,
    question: `支援金が請求されるタイミングはいつですか？`,
    answer: `支援金は毎月月初に自動で請求が行われます。
月途中に支援を開始した場合は、支援を開始したタイミングで最初の月の請求が行われ、翌月以降は月初に請求が行われます。

また、月途中に支援を開始した場合でも1ヶ月分の支援金が請求されます。`
  },
  {
    id: `支援プランの支援金額は税込みですか`,
    question: `支援プランの支援金額は税込みですか`,
    answer: `支援プランの支援金額は税込みの金額が表示されています。`
  },
  {
    id: `支援プランの通話時間とは？`,
    question: `支援プランの通話時間とは？`,
    answer: `支援プランの通話時間は、アバター通話できる毎月の持ち時間を表しています。
通話時間は月単位で管理されるため、毎月月初に通話時間はリセットされます。
余った通話時間を翌月に持ち越すことはできません。`
  },
  {
    id: `支援したい支援プランが選択できない`,
    question: `支援したい支援プランが選択できない`,
    answer: `支援プランの「支援する」ボタンをクリックできない場合、以下の理由が考えられます。
- 既にそのプランを支援している
- そのプランの定員が埋まっている
- VTuberアカウントとしてログインしている`
  },
  {
    id: `同じVTuberの複数プランを支援したい`,
    question: `同じVTuberの複数プランを支援したい`,
    answer: `支援プランは一人のVTuberにつき一つ選択できます。そのため、同じVTuberの複数プランを支援することはできません。`
  },
  {
    id: `アバター通話の予約をしたい`,
    question: `アバター通話の予約をしたい`,
    answer: `通話を予約したいVTuberのお知らせメッセージ画面で、右上に表示されているカレンダーのアイコンをクリックすることで通話予約ページに遷移できます。

通話予約ページで日時や話したい内容を入力し、「決定」ボタンをクリックすると予約内容の確認画面が表示されます。

確認画面で内容を確認し、「予約を確定」ボタンをクリックすることで予約が完了します。`
  },
  {
    id: `アバター通話の予約ができない`,
    question: `アバター通話の予約ができない`,
    answer: `アバター通話の予約ができない場合、以下の理由が考えられます。
- アバターの選択とアバター通話テストが完了していない場合
- 消化されていない予約が2つ以上ある場合
- その月の通話時間を既に使い切っている場合`
  },
  {
    id: `通話予約の一覧を確認したい`,
    question: `通話予約の一覧を確認したい`,
    answer: `ヘッダーのメニュー（≡）をクリックし、「通話予約一覧」を選択することで、通話予約の一覧ページが表示されます。`
  },
  {
    id: `アバター通話の予約をキャンセルしたい`,
    question: `アバター通話の予約をキャンセルしたい`,
    answer: `ヘッダーのメニュー（≡）をクリックし、「通話予約一覧」を選択し、通話予約の一覧ページを開いてください。

キャンセルしたい通話予約の右側の「キャンセル」をクリックすると通話予約のキャンセルページが表示されます。

キャンセルページで、キャンセルメッセージを入力し、「通話をキャンセル」をクリックすることで通話のキャンセルが完了します。
※キャンセルメッセージは通話相手に通知されます

なお、支援者が通話予約をキャンセルした場合、以下のキャンセルポリシーが適用されます。
- 予約した通話日の3日前までのキャンセル：予約した通話時間は全て返還されます
- 予約した通話日の2日前以降のキャンセル：予約した通話時間は全て消費されます

VTuberが通話予約をキャンセルした場合、通話時間の開始前であれば、予約した通話時間は全て返還されます。`
  },
  {
    id: `アバター通話の予約をキャンセルしたら、予約した分の通話時間はどうなりますか？`,
    question: `アバター通話の予約をキャンセルしたら、予約した分の通話時間はどうなりますか？`,
    answer: `支援者が通話予約をキャンセルした場合、以下のキャンセルポリシーが適用されます。
    - 予約した通話日の3日前までのキャンセル：予約した通話時間は全て返還されます
    - 予約した通話日の2日前以降のキャンセル：予約した通話時間は全て消費されます

    VTuberが通話予約をキャンセルした場合、通話時間の開始前であれば、予約した通話時間は全て返還されます。
    `
  },
  {
    id: `アバター通話の当日予約はできますか？`,
    question: `アバター通話の当日予約はできますか？`,
    answer: `アバター通話は通話開始の24時間前まで予約できます。そのため、当日予約はできません。`
  },
  {
    id: `アバター通話の開始時間になったらどうすればいいですか？`,
    question: `アバター通話の開始時間になったらどうすればいいですか？`,
    answer: `アバター通話の開始時間になると、通話相手のメッセージ画面に[通話へ入室]ボタンが表示されます。
ボタンをクリックすることで通話にご入室いただけます。

通話の終了時間になると自動で通話が終了します。`
  },
  {
    id: `アバター通話を撮影、録音、録画してもいいですか？`,
    question: `アバター通話を撮影、録音、録画してもいいですか？`,
    answer: `通話相手のVTuberの許可なくアバター通話を撮影、録音、録画することは禁止されています。アバター通話を撮影、録音、録画する場合は、必ず事前に通話相手のVTuberの許可を取ってください。

また、アバター通話で話した内容を、通話相手のVTuberの許可なく第三者に口外することも禁止されていますのでご注意ください。`
  },
  {
    id: `決済方法を変更したい`,
    question: `決済方法を変更したい`,
    answer: `ヘッダーのメニュー（≡）をクリックし、「支払い方法の変更」を選択し、支払い方法の確認ページを開いてください。

支払い方法の確認ページで、「編集」をクリックすると、支払い方法の変更画面が表示されます。

支払い方法の変更画面で、新しい支払い情報を入力し、「カード情報を登録」ボタンをクリックすることで、新しい支払情報が登録されます。

なお、一度に登録できる支払い情報は一つとなっております。
新しい支払情報を登録した場合、古い支払情報は削除されます。予めご了承ください。`
  },
  {
    id: `通話時間が余ってしまったのですが、翌月に繰り越せますか？`,
    question: `通話時間が余ってしまったのですが、翌月に繰り越せますか？`,
    answer: `通話時間は月単位で管理されるため、毎月月初に通話時間はリセットされます。
そのため、余った通話時間を翌月に持ち越すことはできません。`
  },
  {
    id: `支援しているVTuberに個別メッセージを送りたい`,
    question: `支援しているVTuberに個別メッセージを送りたい`,
    answer: `Laer上で支援しているVTuberに個別にメッセージを送ることはできません。`
  },
  {
    id: `支援先の一覧を確認したい`,
    question: `支援先の一覧を確認したい`,
    answer: `ヘッダーのメニュー（≡）をクリックし、「支援の管理」を選択すると、支援先の一覧が表示されます。`
  },
  {
    id: `支払い履歴を確認したい`,
    question: `支払い履歴を確認したい`,
    answer: `ヘッダーのメニュー（≡）をクリックし、「支払履歴の確認」を選択すると、支払履歴の一覧が表示されます。`
  },
  {
    id: `支援プランを変更したい`,
    question: `支援プランを変更したい`,
    answer: `支援プランを変更する場合、対象のVTuberの支援ページから、変更したい支援プランの「支援する」ボタンをクリックしてください。

支援プラン変更の確認画面が表示されるので、内容を確認し、「支援プランを変更する」ボタンをクリックすることで、支援プランが変更されます。

なお、高額プランへの変更は即時で反映され、低額プランへの変更は翌期から反映されます。
高額プランへの変更の場合、その場で支援金の差額が決済され、差分の通話時間が追加で付与されます。`
  },
  {
    id: `支援をキャンセルしたい`,
    question: `支援をキャンセルしたい`,
    answer: `ユーザーの都合による支援のキャンセルおよび返金はできません。
支援を停止する場合は、「支援を停止したい」をご確認ください。`
  },
  {
    id: `支援を停止したい`,
    question: `支援を停止したい`,
    answer: `ヘッダーのメニュー（≡）をクリックし、「支援の管理」を選択します。

支援先の一覧が表示されるので、キャンセルしたい支援プランの「詳細」をクリックします。

支援内容の詳細が表示されるので、支援内容の下部の「支援をやめる」をクリックします。

支援の停止理由を入力し、「支援を停止する」ボタンをクリックすることで、支援が停止されます。
※支援の停止理由は支援先のVTuberに通知されます

支援を停止しても、支援を停止した月の月末までは引き続きアバター通話等をご利用いただけます。

なお、月の途中で支援を停止した場合でも1ヶ月分の料金が発生します。(当月分は日割り計算になりません)`
  },
  {
    id: `アバター通話を一回もできなかった月でも支援金の決済がされますか？`,
    question: `アバター通話を一回もできなかった月でも支援金の決済がされますか？`,
    answer: `アバター通話を一回もできなかった場合でも毎月支払いが発生します。

Laerはアバター通話の売買ではなく、VTuberの活動を支援するためのサービスです。 ご了承の上、ご利用ください。`
  },
  {
    id: `月の途中で支援を停止した場合、返金されますか？`,
    question: `月の途中で支援を停止した場合、返金されますか？`,
    answer: `月の途中で支援を停止した場合でも1ヶ月分の料金が発生し、返金はされません。(当月分は日割り計算になりません)`
  },
  {
    id: `支援が停止されてしまったのですが、どうすればいいですか？`,
    question: `支援が停止されてしまったのですが、どうすればいいですか？`,
    answer: `決済情報の不備により支援が停止されてしまった場合は、ご登録頂いている決済情報を確認してから、支援先のVTuberの支援ページから再度支援を開始してください。

決済の失敗理由については、ご利用のカード会社に直接お問い合わせください。
なお、一般的な決済失敗理由は以下のようなことが考えられます。

・クレジットカードの限度額を超える決済である
・カードの有効期限が切れている
・プリペイド／デビットカード（Kyash Cardなど）の残高が不足している
・プリペイド／デビットカード（Kyash Cardなど）の発行会社の設定により決済ができない
・定期課金途中で再発行などによるクレジットカード番号の変更があった
・セキュリティの関係上、カード会社で決済に保留がかかった
・クレジットカードが利用できない／無効な状態である`
  },




  {
    type: 'アバター通話'
  },
  {
    id: `アバター通話の動作確認をしたい`,
    question: `アバター通話の動作確認をしたい`,
    answer: `<a href="https://laer.jp/avatar/call-test" target="_blank">こちら</a>からアバター通話の動作を確認していただけます。`
  },
  {
    id: `アバター通話の開始時間になったらどうすればいいですか？`,
    question: `アバター通話の開始時間になったらどうすればいいですか？`,
    answer: `アバター通話の開始時間になると、通話相手のメッセージ画面に[通話へ入室]ボタンが表示されます。
ボタンをクリックすることで通話にご入室いただけます。

通話の終了時間になると自動で通話が終了します。`
  },
  {
    id: `アバター通話で音声を一時的にミュートしたい`,
    question: `アバター通話で音声を一時的にミュートしたい`,
    answer: `アバター通話画面の左下に表示されているマイクアイコンをクリックすることで、音声のオンオフを切り替えられます。`
  },
  {
    id: `アバター通話を一時退室したい`,
    question: `アバター通話を一時退室したい`,
    answer: `アバター通話画面右上に表示されている[✕]アイコンをクリックすることで、アバター通話を退室できます。
通話から退室しても、通話時間内であれば再入室できます。`
  },
  {
    id: `通話画面に入っても通話が始まらない`,
    question: `通話画面に入っても通話が始まらない`,
    answer: `アバター通話に対応していないデバイスまたはブラウザの可能性があります。
必ず通話前に<a href="https://laer.jp/avatar/call-test" target="_blank">こちら</a>で動作確認した環境から通話をご利用ください。

動作確認済みの環境を利用しても通話が始まらない場合、以下の理由が考えられます。
- 通信状況の悪い環境でアバター通話を利用している
- 通話相手がアバター通話に対応していない環境、または通信状況の悪い環境から接続している
- Laerのシステムに障害が発生している

なお、通話に不具合が発生した場合でも原則として返金等はご対応いたしかねますので、予めご了承の上、ご利用ください。`
  },
  {
    id: `音声を認識しない/相手の音声が聞こえない`,
    question: `音声を認識しない/相手の音声が聞こえない`,
    answer: `音声を認識しない/相手の音声が聞こえない場合、以下の理由が考えられます。

- ブラウザのマイクの利用が許可されていない
- アバター通話に対応していないデバイスまたはブラウザを利用している
- 通信状況の悪い環境でアバター通話を利用している
- 通話相手がアバター通話に対応していない環境、または通信状況の悪い環境から接続している
- 利用しているデバイス（スマートフォン、PC、マイク、イヤホン等）が故障している
- Laerのシステムに障害が発生している

アバター通話を利用する際には、必ず事前に<a href="https://laer.jp/avatar/call-test" target="_blank">こちら</a>で動作確認した環境をご利用いただきますようお願いいたします。

なお、通話に不具合が発生した場合でも原則として返金等はご対応いたしかねますので、予めご了承の上、ご利用ください。`
  },
  {
    id: `アバターの表情が変わらない`,
    question: `アバターの表情が変わらない`,
    answer: `アバターの表情が変わらない場合、以下の理由が考えられます。

- ブラウザのWEBカメラの利用が許可されていない
- アバター通話に対応していないデバイスまたはブラウザを利用している
- 通信状況の悪い環境でアバター通話を利用している
- 通話相手がアバター通話に対応していない環境、または通信状況の悪い環境から接続している
- 顔がデバイスのカメラの表情認識の範囲外にある
- 利用しているデバイス（スマートフォン、PC、マイク、イヤホン等）が故障している
- Laerのシステムに障害が発生している

アバター通話を利用する際には、必ず事前に<a href="https://laer.jp/avatar/call-test" target="_blank">こちら</a>で動作確認した環境をご利用いただきますようお願いいたします。

なお、通話に不具合が発生した場合でも原則として返金等はご対応いたしかねますので、予めご了承の上、ご利用ください。`
  },













  {
    type: 'その他'
  },
  {
    id: `ユーザー名やメールアドレス、プロフィール画像を変更したい`,
    question: `ユーザー名やメールアドレス、プロフィール画像を変更したい`,
    answer: `以下の手順でユーザー名やメールアドレス、プロフィール画像を変更できます。

1. ログインがお済みでない場合はログイン
2. ページ右上のヘッダーのメニュー（≡） から「ユーザー情報の変更」を選択
3. 内容を編集して、「変更を保存」をクリック`
  },
  {
    id: `パスワードを変更したい`,
    question: `パスワードを変更したい`,
    answer: `以下の手順でユーザー名やプロフィール画像を変更できます。

1. ログインがお済みでない場合はログイン
2. ページ右上のヘッダーのメニュー（≡） から「ユーザー情報の変更」を選択
3. 必要情報を入力して、「パスワードを変更」をクリック`
  },
  {
    id: `お知らせのメールが届かない`,
    question: `お知らせのメールが届かない`,
    answer: `お知らせのメールが届かない場合、以下をご確認ください。

- 入力したメールアドレスに誤りがないか
- 迷惑メールフォルダや別のフォルダに入っていないか
- noreply@laer.jp, support@laer.jp からのメールを受信拒否に設定していないか`
  },
  {
    id: `不具合を発見した/機能を改善・追加してほしい`,
    question: `不具合を発見した/機能を改善・追加してほしい`,
    answer: `不具合報告や機能改善・追加依頼については、<a href="https://forms.gle/Qr1MsVNbSYc8PdYm8" target="_blank">こちら</a>のフォームよりご連絡ください。`
  },
  {
    id: `よくある質問を全て確認したが問題を解決できなかった`,
    question: `よくある質問を全て確認したが問題を解決できなかった`,
    answer: `法令に係る事柄や、重要性・緊急性の高いお問い合わせの場合は、support@laer.jp までお問い合わせください。

※上記サポートアドレスは法令に係る事柄や、重要性・緊急性の高いお問い合わせ専用の窓口となっております。それ以外の事柄は原則として返信いたしかねますので予めご了承ください。

不具合報告や機能改善・追加依頼については、<a href="https://forms.gle/Qr1MsVNbSYc8PdYm8" target="_blank">こちら</a>のフォームよりご連絡ください。`
  }
];
